/** Minimum review text length (chars) before a phrase-match request is fired */
export const MIN_CHARS_FOR_MATCH = 5;

/** Debounce delay (ms) between keystrokes and a phrase-match request */
export const MATCH_INPUT_DEBOUNCE_MS = 150;
